import { PropsWithChildren } from "react";
import { withUIProtection } from "../../hoc/withUIProtection";
import { CustomerProvider } from "../../providers/CustomerProvider";
import { CustomerTable } from "./CustomerTable";

type Props = PropsWithChildren & {
  asContainer?: boolean;
};

const Customer = ({ children, asContainer = true, ...rest }: Props) => {
  return (
    <CustomerProvider {...rest}>
      <div data-name="customer">{children}</div>
    </CustomerProvider>
  );
};

// Apply UI protection to the subcomponents
const ProtectedCustomerTable = withUIProtection(CustomerTable);

// Attach the protected subcomponents to the ProtectedPayment component
Customer.CustomerTable = ProtectedCustomerTable;

export { Customer };

// Export individual protected components
export { ProtectedCustomerTable as CustomerTable };
